<template>
  <div
    class="wlx-unified-login-wrapper wlx-basic-static-wrapper"
    style="height: auto"
  >
    <!--登陆弹窗-->
    <el-dialog
      :show-close="true"
      :visible.sync="scanVisible"
      top="12%"
      :close-on-click-modal="false"
      width="500px"
      class="unified-login-dialog-style"
    >
      <div class="login-hade-tab clearfix">
        <div class="user-account-login active_login">
          <span style="float: left">账号登录</span>
        </div>
      </div>
      <div class="login-form-input clearfix">
        <el-form ref="form" :model="ruleForm" :rules="rules">
          <div class="from-account-login">
            <el-form-item prop="userName">
              <el-input
                placeholder="请输入账号"
                prefix-icon="wl-icon-user"
                v-model="idCard"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                placeholder="请输入密码"
                prefix-icon="wl-icon-mimaicon"
                v-model="ruleForm.password"
                type="password"
                @keyup.enter.native="login()"
              ></el-input>
            </el-form-item>
          </div>
          <el-form-item>
            <el-button type="primary" @click="login">登录</el-button>
          </el-form-item>
          <div class="forget-password p-enter-register">
            <!-- <span class="sp-forget-pass pass-link" @click="rememberPassword">忘记密码</span>
            <span class="sp-line">|</span> -->
            <span class="sp-forget-pass" @click="enterRegister">注册</span>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog
      :show-close="true"
      :visible.sync="registerVisible"
      top="12%"
      :close-on-click-modal="false"
      width="700px"
      class="unified-login-dialog-style"
    >
      <el-form ref="form" :model="regForm" :rules="rules">
        <div class="from-account-login">
          <el-form-item prop="displayName" label="姓名：">
            <el-input
              placeholder="请输入姓名"
              v-model="displayName"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item prop="idCard" label="证件号：">
            <el-input
              placeholder="请输入证件号"
              v-model="idCard"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item prop="moblie" label="手机号：">
            <el-input
              placeholder="请输入手机号"
              v-model="regForm.mobile"
            ></el-input>
          </el-form-item>

          <el-form-item prop="verifycode" label="验证码：">
            <el-input
              class="input-code-con"
              v-model="regForm.verifycode"
              placeholder="请输入验证码"
              @keyup.enter.native="login"
            ></el-input>
            <div class="change-code-btn" v-if="show1" @click="sendMessage()">
              发送验证码
            </div>
            <div class="change-code-btn" v-if="show2">{{ count }}s</div>
            <div class="change-code-btn" v-if="show3" @click="sendMessage()">
              重新获取验证码
            </div>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary" @click="register">注册</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Bus from "components/bus.js";
import { MU_UPATE_AUTH, MU_UPATE_SCHOOL } from "store/index";
import CryptoJS from "crypto-js";
export default {
  data() {
    return {
      scanVisible: false,
      registerVisible: false,
      show1: true,
      show2: false,
      show3: false,
      count:60,
      ruleForm: {
        schoolId: "",
        userName: "",
        password: "",
        phone: "",
        captcha: "",
      },
      regForm: {
        displayName: "",
        idCard: "",
        moblie: "",
        verifycode:""
      },
      rules: {
        idCard: [
          { required: true, message: "请输入用户账号", trigger: "change" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "change" },
        ],
        phone: [{ required: true, message: "请输入手机号", trigger: "change" }],
        captcha: [
          { required: true, message: "请输入验证码", trigger: "change" },
        ],
      },
      schoolList: [],
    };
  },
  props: {
    isShow: {
      type: Object,
    },
    isJumpWeb: {
      type: Boolean,
      default: false,
    },
    idCard: {
      type: String,
    },
    displayName: {
      type: String,
    },
  },
  computed: {
    userInfo() {
      return this.$store.state.auth;
    },
    association: function () {
      return this.$store.state.association;
    },
  },
  created() {
    if (localStorage["userId"] !== undefined) {
      this.$store.dispatch(MU_UPATE_AUTH).then((rt) => {});
    }
    this.$store.dispatch(MU_UPATE_SCHOOL, { id: window.location.href });
  },
  watch: {
    isShow(val) {
      this.scanVisible = val.isShow;
    },
  },
  methods: {
    enterRegister() {
      // this.$router.push({
      //     name:'register'
      // });
      this.scanVisible = false;
      this.registerVisible = true;
    },
    // 忘记密码
    rememberPassword() {
      this.$router.push({
        name: "password",
      });
    },
    openLoginDialog() {
      this.scanVisible = true;
    },
    sendMessage() {
      var once = true;
      let str_ = Date.parse(new Date()) / 1000;
      let str = this.encryption(str_);
      let str1 = CryptoJS.MD5(str_ + "").toString();
      var s1 = str1.substring(0, 7);
      var s2 = str1.substring(7);
      str1 = s1 + "s" + s2;
      var re = /^1\d{10}$/;

      if (!re.test(this.regForm.mobile)) {
        this.$message.warning("手机号格式不正确");
        return false;
      }
      if (once) {
        var that = this;

        this.$http
          .post("/api/XOrg/XLogin/sendCode", {
            verifyInfo: this.regForm.mobile,
            str: str,
            str1: str1,
          })
          .then((rst) => {
            if (rst.code > 0) {
              this.$message.success(rst.msg);
              const TIME_COUNT = 60;
              if (!this.timer) {
                this.count = TIME_COUNT;
                this.show1 = false;
                this.show2 = true;
                this.show3 = false;
                this.timer = setInterval(() => {
                  if (this.count > 0 && this.count <= TIME_COUNT) {
                    this.count--;
                    once = false;
                  } else {
                    this.show1 = false;
                    this.show2 = false;
                    this.show3 = true;
                    clearInterval(this.timer);
                    this.timer = null;
                    once = true;
                  }
                }, 1000);
              }
            } else {
              this.$message.warning(rst.msg);
            }
          });
      }
    },
       encryption: function (str) {
            let Base64 = require("js-base64").Base64;
            return Base64.encode(str);
        },
    login: function () {
      var that = this;
      this.loadingTip(true);
      this.$http
        .post("/api/XOrg/XLogin/gwLoginVerfy", {
          userName: that.idCard,
          pwd: that.ruleForm.password,
        })
        .then((rst) => {
          debugger;
          if (rst.userInfo.code > 0) {
            localStorage["userName"] = this.ruleForm.userName;
            localStorage["userId"] = rst.userId;
            this.loadingTip(false);
            // this.checkLogin(that.ruleForm.userName,that.ruleForm.password,rst.userInfo.displayName,rst.userInfo.mobile);
            this.$emit("done", rst.userInfo);
          } else {
            this.loadingTip(false);
            this.$message.warning(rst.userInfo.msg);
          }
        });
    },
    register() {
      this.$http
        .post("/api/XOrg/XLogin/gwResigerVerfy", {
          idCard: this.idCard,
          displayName: this.displayName,
          mobile: this.regForm.mobile,
          shortMessage: this.regForm.verifycode
        })
        .then((rst) => {
          if (rst.code>0&&rst.msgInfo.code > 0) {
            this.$message.success("注册成功");
            this.registerVisible = false;
          } else {
            if(rst.code<0)
            {
            this.$message.warning(rst.msg);
            }

            else{
              this.$message.warning(rst.msgInfo.msg);
            }
          }
        });
    },
    checkLogin(userName, pwd, displayName, moblie) {
      debugger;
      this.$http
        .post("/api/XOrg/XLogin/checkUserInfo", {
          userName: userName,
          pwd: pwd,
          displayName: displayName,
          mobile: moblie,
        })
        .then((rst) => {
          if (rst.code > 0) {
            this.scanVisible = false;
          }
        });
    },
    loadingTip(is) {
      if (is) {
        this.$loading({
          lock: true,
          text: "正在登录...",
        });
      } else {
        this.$loading({}).close();
      }
    },
    target_() {
      let Urlname = "";
      if (this.$store.state.auth.userType === 1) {
        Urlname = "stuBasicInfo";
      } else if (this.$store.state.auth.userType === 2) {
        Urlname = "teaApply";
      } else if (this.$store.state.auth.userType === 3) {
        Urlname = "siteBasicInfo";
      } else if (this.$store.state.auth.userType === 5) {
        Urlname = "managerIndex";
      }
      return Urlname;
    },
  },
};
</script>

<style lang="scss">
.wlx-unified-login-wrapper {
  .input-code-con {
    width: 180px;

    .el-input__inner {
      border-radius: 6px;
    }
  }

  .change-code-btn {
    display: inline-block;
    margin-left: 24px;
    cursor: pointer;
    color: #008aec;
  }
}
</style>
